import { Anchor } from "../Anchor";
import { Button, Col, Divider, Row, Typography } from "antd";
import {
	FacebookOutlined,
	InstagramOutlined,
	LinkedinOutlined,
	YoutubeOutlined,
} from "@ant-design/icons";
import { FixedSizeWrapper } from "./Layout";
import { Link } from "react-router-dom";
import { Logo } from "../Logo";
import { pathOr } from "ramda";
import { useVersion } from "../../../hooks/version";
import React, { useGlobal } from "reactn";
import moment from "moment";
import styled from "styled-components";

const { Title, Text } = Typography;

export const Footer = () => {
	const version = useVersion();
	const [reservationsv3] = useGlobal("reservationsv3");

	const oldIdReservation = pathOr(
		false,
		["oldIdReservation"],
		reservationsv3
	);

	const socialMedia = [
		{
			icon: <FacebookOutlined></FacebookOutlined>,
			link: "https://www.facebook.com/zeroq.ok",
		},
		{
			icon: <InstagramOutlined></InstagramOutlined>,
			link: "https://www.instagram.com/zeroq.ok/",
		},
		{
			icon: <YoutubeOutlined></YoutubeOutlined>,
			link: "https://www.youtube.com/watch?v=uUKPTjOrBdg",
		},
		{
			icon: <LinkedinOutlined></LinkedinOutlined>,
			link: "https://www.linkedin.com/company/zeroq/?originalSubdomain=cl",
		},
	];
	return (
		<Container>
			<FixedSizeWrapper>
				<Row
					align="middle"
					gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
					style={{ paddingBottom: 24 }}
				>
					<Col span={6}>
						<Row justify="end">
							<Col span={24}>
								<Logo width={148}></Logo>
							</Col>
						</Row>
					</Col>
					{!oldIdReservation && (
						<>
							<Col span={10}>
								<Row justify="center">
									<Col span={12}>
										<Row>
											<Col>
												<Title
													style={{
														color: "#798dc6",
														margin: 0,
													}}
													level={4}
												>
													Comercial
												</Title>
											</Col>
										</Row>
										<Row>
											<Col span={4}>
												<StyledDivider></StyledDivider>
											</Col>
										</Row>
										<Row>
											<Col>
												<Anchor link="https://comercial.zeroq.cl/totems-inteligentes">
													<StyledText>
														Productos
													</StyledText>
												</Anchor>
											</Col>
										</Row>
										<Row>
											<Col>
												<Anchor link="https://comercial.zeroq.cl/contacto">
													<StyledText>
														Contacta con un vendedor
													</StyledText>
												</Anchor>
											</Col>
										</Row>
									</Col>
									<Col span={12}>
										<Row>
											<Col>
												<Title
													style={{
														color: "#798dc6",
														margin: 0,
													}}
													level={4}
												>
													Soporte
												</Title>
											</Col>
										</Row>
										<Row>
											<Col span={4}>
												<StyledDivider></StyledDivider>
											</Col>
										</Row>
										<Row>
											<Col>
												<Link to={"/faq"}>
													<StyledText>
														Preguntas Frecuentes
													</StyledText>
												</Link>
											</Col>
										</Row>
									</Col>
								</Row>
							</Col>
							<Col span={6}>
								<Row
									justify="start"
									align="middle"
									gutter={{ xs: 8, sm: 8, md: 16, lg: 16 }}
								>
									{socialMedia.map(({ icon, link }, i) => (
										<Col key={i}>
											<Anchor link={link}>
												<StyledIcon>{icon}</StyledIcon>
											</Anchor>
										</Col>
									))}
								</Row>
								<Row>
									<Col>
										<Anchor link="https://comercial.zeroq.cl/blog">
											<StyledButton
												ghost
												shape="round"
												size="large"
											>
												<Title
													style={{
														margin: 0,
														color: "#798dc6",
													}}
													level={5}
												>
													Blog ZeroQ
												</Title>
											</StyledButton>
										</Anchor>
									</Col>
								</Row>
							</Col>
						</>
					)}
				</Row>
				<Row>
					<Col span={24}>
						<StyledBottomDivider
							type="horizontal"
							plain
						></StyledBottomDivider>
					</Col>
				</Row>
				<Row
					justify="space-around"
					align="middle"
					style={{ textAlign: "center" }}
				>
					<Col
						span={10}
						style={{
							color: "#798dc6",
						}}
					>
						{`Todos los derechos reservados © ${moment().year()} ZeroQ`}
						<StyledBottomDivider type="vertical"></StyledBottomDivider>
						{version}
					</Col>
				</Row>
			</FixedSizeWrapper>
		</Container>
	);
};

const Container = styled.div`
    width: 100%;
    minHeight: 100vh,
    margin: 0 auto;
    padding: 6rem 1.5rem 1rem;
    bottom: 0;
    background-color: #145ab4;
    background-image: linear-gradient(238deg, #0d50b3, #490c6e);
`;

const StyledText = styled(Text)`
	color: #fff;
	&:hover {
		text-decoration: underline;
	}
`;
const StyledIcon = styled.div`
	font-size: 24px;
	color: #798dc6;
`;
const StyledDivider = styled(Divider)`
	background: #4c78dc;
`;
const StyledBottomDivider = styled(Divider)`
	background: #145ab4;
`;
const StyledButton = styled(Button)`
	margin-top: 24px;
	width: 100%;
	border-color: #798dc6;
	color: #798dc6;
`;
